import { HttpClient } from '@angular/common/http';
import 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UserProfileService = /** @class */ (function () {
    function UserProfileService(http, baseUrl) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.apiUrl = this.baseUrl + "api/userprofile";
    }
    UserProfileService.prototype.getUser = function (id) {
        return this.http.get(this.apiUrl + "/" + id);
    };
    UserProfileService.prototype.putUser = function (id, userProfileModel) {
        return this.http.put(this.apiUrl + "/" + id, userProfileModel);
    };
    UserProfileService.prototype.isProvincePostalCodeMismatch = function (id) {
        return this.http.get(this.apiUrl + "/postalCodeMismatch/" + id);
    };
    UserProfileService.ngInjectableDef = i0.defineInjectable({ factory: function UserProfileService_Factory() { return new UserProfileService(i0.inject(i1.HttpClient), i0.inject("BASE_URL")); }, token: UserProfileService, providedIn: "root" });
    return UserProfileService;
}());
export { UserProfileService };
